import { baseURLImg } from '@/services/constants/app';

export const getImageUrl = (imageName: string) =>
    imageName.startsWith('http') ? imageName : `${baseURLImg}Images/${imageName.replace(/^\/+/, '')}`;
